// extracted by mini-css-extract-plugin
module.exports = {"SideDrawler":"SideDrawler_SideDrawler__OsJtL","CloseIcon":"SideDrawler_CloseIcon__2Xnjm","Open":"SideDrawler_Open__2_7xE","Close":"SideDrawler_Close__3RwfK"};